<template lang="html">
  <div id="register-page">

    <section class="main-section">
      <b-form @submit="onSubmit">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-lg-8 col-form">
              <div class="d-block">
                <h2 class="mb-2 text-center title-s1">Aplica para ser operador de camión</h2>

                <p class="text-center txt-c">Completa el siguiente formulario y nos pondremos en contacto contigo a la brevedad.</p>
              </div>

              <div class="box-white">
                <div class="row" v-if="step <= 2">
                  <div class="col-12 col-steps">
                    <h3 class="title">Formulario de Aplicación</h3>
                    <p>
                      <span v-if="step == 1">Paso 1 de 3 - Información Personal</span>
                      <span v-if="step == 2">Paso 2 de 3 - Documentos y Datos Personales (Opcional)</span>
                    </p>
                    <b-progress :value="step" :max="3" height="10px"></b-progress>

                    <div class="alert alert-warning mb-2" role="alert" v-if="step == 2">Todos los campos en esta sección son opcionales. Puedes completarlos ahora o más adelante.</div>
                  </div>
                </div>

                <!-- Paso 1 -->
                <div class="row" v-if="step == 1">
                  <div class="col-lg-6 col-input">
                    <b-form-group class="custom-f-group-1"
                      label="Nombre">
                      <b-form-input
                        v-model="form.name"
                        type="text"
                        placeholder=""
                        required
                      ></b-form-input>
                    </b-form-group>
                  </div>

                  <div class="col-lg-6 col-input">
                    <b-form-group class="custom-f-group-1"
                      label="Apellidos">
                      <b-form-input
                        v-model="form.lastname"
                        type="text"
                        placeholder=""
                        required
                      ></b-form-input>
                    </b-form-group>
                  </div>

                  <div class="col-lg-6 col-input">
                    <b-form-group class="custom-f-group-1"
                      label="Teléfono">
                      <b-form-input
                        v-model="form.phone"
                        type="text"
                        placeholder=""
                        minlength="10"
                        maxlength="10"
                        required
                      ></b-form-input>
                    </b-form-group>
                  </div>

                  <div class="col-lg-6 col-input">
                    <b-form-group class="custom-f-group-1"
                      label="Email">
                      <b-form-input
                        v-model="form.email"
                        type="email"
                        placeholder=""
                        required
                      ></b-form-input>
                    </b-form-group>
                  </div>

                  <div class="col-12 text-right col-input pt-1">
                    <b-button type="submit" class="btn-s1 bg-1">Siguiente</b-button>
                  </div>
                </div>
                <!--  -->

                <!-- Paso 2 -->
                <div class="row" v-if="step == 2">
                  <div class="col-12 col-titles">
                    <h5 class="subtitle-1">Información Personal</h5>
                  </div>

                  <div class="col-lg-6 col-input">
                    <b-form-group class="custom-f-group-1"
                      label="Fecha de nacimiento">
                      <b-form-input
                        v-model="form.date_birth"
                        type="date"
                        placeholder=""
                      ></b-form-input>
                    </b-form-group>
                  </div>

                  <div class="col-lg-6 col-input">
                    <b-form-group class="custom-f-group-1"
                      label="Lugar de Residencia en México">
                      <b-form-input
                        v-model="form.state"
                        type="text"
                        placeholder="Ciudad, Estado"
                      ></b-form-input>
                    </b-form-group>
                  </div>

                  <div class="col-12 col-line">
                    <hr class="mt-" />
                  </div>

                  <div class="col-12 col-titles">
                    <h5 class="subtitle-1">Licencia Federal</h5>
                  </div>

                  <div class="col-lg-6 col-input">
                    <b-form-group class="custom-f-group-1"
                      label="Número de licencia B1">
                      <b-form-input
                        v-model="form.license_number"
                        type="text"
                        placeholder="Número de licencia"
                      ></b-form-input>
                    </b-form-group>
                  </div>

                  <div class="col-lg-6 col-input">
                    <b-form-group class="custom-f-group-1"
                      label="Ajunto de Licencia B1"
                      description="Formatos aceptados: JPG, PNG, PDF. Máximo 5MB">
                      <b-form-file accept=".jpg,.jpeg,.png,.pdf" v-model="form.licenciaFile" plain></b-form-file>
                    </b-form-group>
                  </div>

                  <div class="col-12 col-line">
                    <hr class="mt-" />
                  </div>

                  <div class="col-12 col-titles">
                    <h5 class="subtitle-1">Pasaporte</h5>
                  </div>

                  <div class="col-lg-6 col-input">
                    <b-form-group class="custom-f-group-1"
                      label="Número de pasaporte">
                      <b-form-input
                        v-model="form.passport_number"
                        type="text"
                        placeholder="Número de pasaporte"
                      ></b-form-input>
                    </b-form-group>
                  </div>

                  <div class="col-lg-6 col-input">
                    <b-form-group class="custom-f-group-1"
                      label="Fecha de expiración">
                      <b-form-input
                        v-model="form.passport_expiry"
                        type="date"
                        placeholder=""
                      ></b-form-input>
                    </b-form-group>
                  </div>

                  <div class="col-lg-12 col-input">
                    <b-form-group class="custom-f-group-1"
                      label="Adjunto de Pasaporte"
                      description="Formatos aceptados: JPG, PNG, PDF. Máximo 5MB">
                      <b-form-file accept=".jpg,.jpeg,.png,.pdf" v-model="form.passportFile" plain></b-form-file>
                    </b-form-group>
                  </div>

                   <div class="col-12 col-line">
                    <hr class="mt-" />
                  </div>
                  <div class="col-12 col-titles">
                    <h5 class="subtitle-1">VISA B1  </h5>
                  </div>

                  <div class="col-lg-6 col-input">
                    <b-form-group class="custom-f-group-1"
                      label="Número de visa">
                      <b-form-input
                        v-model="form.visa"
                        type="text"
                        placeholder="Número de visa"
                      ></b-form-input>
                    </b-form-group>
                  </div>


                  <div class="col-lg-12 col-input">
                    <b-form-group class="custom-f-group-1"
                      label="Adjunto de Visa"
                      description="Formatos aceptados: JPG, PNG, PDF. Máximo 5MB">
                      <b-form-file accept=".jpg,.jpeg,.png,.pdf" v-model="form.visaFile" plain></b-form-file>
                    </b-form-group>
                  </div>


                  <div class="col-12 col-line">
                    <hr class="mt-" />
                  </div>

                  <div class="col-12 col-titles">
                    <h5 class="subtitle-1">CURP</h5>
                  </div>

                  <div class="col-lg-6 col-input">
                    <b-form-group class="custom-f-group-1"
                      label="Número de CURP">
                      <b-form-input
                        v-model="form.curp"
                        type="text"
                        placeholder="CURP (18 caracteres)"
                      ></b-form-input>
                    </b-form-group>
                  </div>

                  <div class="col-lg-6 col-input">
                    <b-form-group class="custom-f-group-1"
                      label="Adjunto de CURP"
                      description="Formatos aceptados: JPG, PNG, PDF. Máximo 5MB">
                      <b-form-file accept=".jpg,.jpeg,.png,.pdf" v-model="form.curpFile" plain></b-form-file>
                    </b-form-group>
                  </div>

                  <div class="col-12 col-line">
                    <hr class="mt-" />
                  </div>

                  <div class="col-12 col-titles">
                    <h5 class="subtitle-1">Fotografía</h5>
                  </div>

                  <div class="col-lg-6 col-input">
                    <b-form-group class="custom-f-group-1"
                      label="Foto de identificación"
                      description="Formatos aceptados: JPG, PNG, PDF. Máximo 5MB">
                      <b-form-file accept=".jpg,.jpeg,.png,.pdf" v-model="form.image" plain></b-form-file>
                    </b-form-group>
                  </div>

                  <div class="col-12 col-line">
                    <hr class="mt-" />
                  </div>

                  <div class="col-12 col-titles">
                    <h5 class="subtitle-1">Términos y Condiciones</h5>
                  </div>

                  <div class="col-12 col-input">
                    <div class="p-3 border rounded">
                      <b-form-checkbox class="custom-checkbox-1"
                        v-model="form.checkbox1"
                        required
                        name="checkbox-1"
                        :value="true"
                        :unchecked-value="false">
                        <p>Acepto el <router-link target="_blank" to="/aviso-de-privacidad"><u>Aviso de privacidad</u></router-link></p>
                        <p class="mt-1 text-muted small">He leído y acepto el Aviso de Privacidad de Marquez Express.</p>
                      </b-form-checkbox>
                    </div>

                    <div class="p-3 mt-3 border rounded">
                      <b-form-checkbox class="custom-checkbox-1"
                        v-model="form.checkbox2"
                        required
                        name="checkbox-1"
                        :value="true"
                        :unchecked-value="false">
                        <p>Acepto las <router-link target="_blank" to="/politicas-de-contratacion"><u>Políticas de contratación</u></router-link></p>
                        <p class="mt-1 text-muted small">He leído y acepto las Políticas de contratación de Marquez Express.</p>
                      </b-form-checkbox>
                    </div>
                  </div>

                  <div class="col-12 col-input pt-4">
                    <div class="row">
                      <div class="col-6 text-left">
                        <a class="btn btn-s1 outline-1" @click="step = 1">Anterior</a>
                      </div>

                      <div class="col-6 text-right">
                        <b-button type="submit" class="btn-s1 bg-1">Siguiente</b-button>
                      </div>
                    </div>
                  </div>
                </div>
                <!--  -->

                <!-- Paso 3 -->
                <div class="row" v-if="step == 3">
                  <div class="col-12 col-completed">
                    <div class="d-block mb-3">
                      <i class="fa-regular fa-circle-check icon"></i>
                    </div>

                    <h5 class="subtitle-2">¡Solicitud Enviada!</h5>

                    <h6 class="mt-3 text-muted" style="line-height: 1.5;">Gracias por tu interés en unirte a Marquez Express. Hemos recibido tu solicitud y nos pondremos en contacto contigo pronto.</h6>

                    <p class="mt-3">
                      <a class="btn btn-s1 outline-1" @click="step = 1">Enviar otra solicitud</a>
                    </p>
                  </div>
                </div>
                <!--  -->
              </div>
            </div>
          </div>
        </div>
      </b-form>
    </section>

  </div>
</template>

<script>
export default {
  data() {
    return {
      step: 1,

      form: {
        name: null,
      }
    }
  },

  methods: {
    onSubmit(event) {
      event.preventDefault();

      if(this.step == 2) {
				this.$root.isLoading = true;

        const formData = new FormData();

        Object.entries(this.form).forEach(([key, value]) => {
          if (value instanceof File) {
            // Para campos tipo archivo (como el b-form-file)
            formData.append(key, value);
          } else if (Array.isArray(value)) {
            // Si hay arrays (como v-select múltiple), agregarlos como múltiples campos
            value.forEach((val, index) => {
              formData.append(`${key}[${index}]`, val);
            });
          } else if (value !== null && value !== undefined) {
            // Para campos normales
            formData.append(key, value);
          }
        });


				axios.post(tools.url("/api/drivers"),formData).then((response)=>{
						this.step = 3;
					  this.$root.isLoading = false;
				}).catch((error)=>{
					  alert(error);
					  this.$root.isLoading = false;
				});

      }
      if(this.step == 1) {
        this.step = 2;
      }
    },
  },
}
</script>
